import { useDbpjkitWorkerJobRerun, useDbpjkitWorkerJobRerunValidation } from "~/features/dbpjkitWorkerJobs/hooks";
import { DbpjkitWorkerJobRerunDialogPresenter } from "./DbpjkitWorkerJobRerunDialogPresenter";

interface DbpjkitWorkerJobRerunDialogProps {
  jobId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Two-step rerun dialog: on open it asks Cnut whether the job is rerunnable
 * (showing the reasons when it is not), then offers "rerun as dry run" and
 * "rerun live". Closes itself only when the mutation succeeded.
 */
export function DbpjkitWorkerJobRerunDialog({ jobId, open, onOpenChange }: DbpjkitWorkerJobRerunDialogProps) {
  const { validating, rerunnable, reasons, dryRunSupported } = useDbpjkitWorkerJobRerunValidation(jobId, {
    skip: !open,
  });
  const { onRerun, rerunning } = useDbpjkitWorkerJobRerun();

  const handleRerun = async (dryRun: boolean) => {
    const succeeded = await onRerun(jobId, dryRun);
    if (succeeded) {
      onOpenChange(false);
    }
  };

  return (
    <DbpjkitWorkerJobRerunDialogPresenter
      open={open}
      onOpenChange={onOpenChange}
      validating={validating}
      rerunnable={rerunnable}
      dryRunSupported={dryRunSupported}
      reasons={reasons}
      rerunning={rerunning}
      onRerun={handleRerun}
    />
  );
}
